import React from 'react';
import Button from '../../components/Button';
import FontAwesomeIcon from '../../components/Icon';
import PropertyForm from '../../components/PropertyForm';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';

interface PropertyHeaderActionsProps {
  property: any;
  canManageProperty: boolean;
  canDeleteProperty: boolean;
  isDeleteModalOpen: boolean;
  isPropertyFormOpen: boolean;
  propertyFormInitialData: any;
  propertyFormInitialModulePermissions: any[];
  tabList: any[];
  onOpenPropertyForm: (property: any) => void;
  onClosePropertyForm: () => void;
  onSaveProperty: (data: any) => Promise<{ ok: boolean }>;
  onOpenDeleteModal: () => void;
  onCloseDeleteModal: () => void;
  onDeleteProperty: (property: any) => void;
}

const PropertyHeaderActions = ({
  property,
  canManageProperty,
  canDeleteProperty,
  isDeleteModalOpen,
  isPropertyFormOpen,
  propertyFormInitialData,
  propertyFormInitialModulePermissions,
  tabList,
  onOpenPropertyForm,
  onClosePropertyForm,
  onSaveProperty,
  onOpenDeleteModal,
  onCloseDeleteModal,
  onDeleteProperty,
}: PropertyHeaderActionsProps) => {
  if (!canManageProperty) {
    return null;
  }

  return (
    <>
      <Button
        color="semantic"
        onClick={() => onOpenPropertyForm(property)}
        label={<FontAwesomeIcon glyph="pencil" weight="light" />}
      />

      {canDeleteProperty ? (
        <>
          <Button
            color="semantic"
            onClick={() => onOpenDeleteModal()}
            label={<FontAwesomeIcon glyph="trash" weight="light" />}
          />

          {isDeleteModalOpen && (
            <ConfirmationModal
              variant="danger"
              title={`Delete Property ${property.name}?`}
              confirmLabel="Yes, Delete Everything"
              cancelLabel="Go Back"
              requireTypeToConfirm={true}
              confirmationWord="DELETE"
              message={
                <div>
                  <p>
                    You are about to <strong>permanently delete</strong> this
                    entire property.
                  </p>
                  <p className="property-delete-message-note">
                    Doing so will immediately destroy all data associated with{' '}
                    <strong>{property.name}</strong>, including:
                  </p>
                  <ul className="property-delete-message-list">
                    <li>All Buildings and Suites</li>
                    <li>All Associated Homeowner and Occupant records</li>
                    <li>
                      Associated Walkthrough history, Signatures, and Documents
                    </li>
                    <li>All Associated Service Requests and Notes</li>
                  </ul>
                </div>
              }
              warningMessage="This action is irreversible. All property data will be lost forever."
              onCancel={() => onCloseDeleteModal()}
              onConfirm={() => {
                onDeleteProperty(property);
                onCloseDeleteModal();
              }}
            />
          )}
        </>
      ) : null}

      {isPropertyFormOpen && (
        <PropertyForm
          onClose={onClosePropertyForm}
          tabList={tabList}
          onSaveProperty={(data: any) => onSaveProperty(data)}
          initialData={propertyFormInitialData}
          initialModulePermissions={propertyFormInitialModulePermissions}
        />
      )}
    </>
  );
};

export default PropertyHeaderActions;